import React from 'react'

export default function HomeBanner({src}) {
  return (
    <div className='common-top-bottom-gap'>
        <img src={`${src}`} alt="" className='w-full'/>
    </div>
  )
}
